const initialState = () => {
  return {
      loading: false,
      errors: null,
      data: null,
      configuration: {
          title: null,
          description: null,
          requiresPayment: true,
          estoreConfiguration: {
            productClasses:[]          
          }
      },
      productClass:{
        productClassId: null,        
        products:[],
        shippingType:null,
        type:null,
        description:''
      },
      permitNumber: null,
      orderSummary: null,
      OrderDetails: null
  };
};

export default initialState;